import { useState, useEffect, useCallback } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '../services/firebaseService';
import {
  getAccountSettingsPath,
  setBusinessScaleOverride,
  type BusinessScaleOverrideValue,
} from '../services/businessScaleOverrideService';

export function useBusinessScaleOverride(
  shareBookId: string | null,
  accountNumber: number
): {
  isBusinessScaleOverrideUnder5: boolean;
  setOverride: (under5: boolean) => Promise<void>;
  loading: boolean;
} {
  const [value, setValue] = useState<BusinessScaleOverrideValue>('auto');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!shareBookId) {
      setValue('auto');
      setLoading(false);
      return;
    }
    const ref = doc(db, getAccountSettingsPath(shareBookId), `account_${accountNumber}`);
    setLoading(true);
    const unsub = onSnapshot(
      ref,
      (snap) => {
        const v = snap.exists() ? snap.data()?.business_scale_override : null;
        setValue(v === 'under5' ? 'under5' : 'auto');
        setLoading(false);
      },
      () => {
        setValue('auto');
        setLoading(false);
      }
    );
    return () => unsub();
  }, [shareBookId, accountNumber]);

  const setOverride = useCallback(
    async (under5: boolean) => {
      if (!shareBookId) return;
      await setBusinessScaleOverride(shareBookId, accountNumber, under5 ? 'under5' : 'auto');
    },
    [shareBookId, accountNumber]
  );

  return {
    isBusinessScaleOverrideUnder5: value === 'under5',
    setOverride,
    loading,
  };
}
